export const canAccessClearCustoms = (authContext) => {
  const isSubscribedToClearCustoms = authContext?.userData?.userInfo?.userSubscriptions
  ?.map((i) => i?.productType)
  ?.includes("CLEARCUSTOMS");

  const requiredRoles = [
    "ClearCustoms Admin",
    "ClearCustoms User",
    "ClearCustoms Report"
  ];

  const hasRequiredRoles = requiredRoles.some((role) =>
    authContext?.userData?.roles?.includes(role)
  );

  return isSubscribedToClearCustoms && hasRequiredRoles;
};
